import React from 'react';

const Footer = () => {
    return (
        <div className='p-5 mt-5' style={{ background: '#03031824' }}>
            <p className='text-center text-white mb-0'>Copyright © 2022 Jhon Smith Photography</p>
        </div>
    );
};

export default Footer;